import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import loadimg from "../images/pp-logo.gif";

const TestProtectedRoute = ({ children, hasSubscription,free_test_slug,randomTest }) => {

  const token = localStorage.getItem("token");
  const location = useLocation();
  const { slug } = useParams();

    if (
          !hasSubscription ||
          hasSubscription.user_can_attend === undefined ||
          !Array.isArray(hasSubscription.test_user_slugs)
      ) {
          return (

             <div className="loadingDiv" >
              
                  <img src={loadimg}  alt="Loading..." />
      
              </div>
          );
      }

    const allowedSlugs = hasSubscription?.test_user_slugs || [];

    if (
      (hasSubscription.user_can_attend === false && 
       !allowedSlugs?.includes(slug))
    ) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    if (free_test_slug ===slug) {

        return <Navigate to={`/${free_test_slug}`} replace state={{ from: location }} />;
    }

    // if (
    //   Array.isArray(randomTest) &&
    //   randomTest.some(item => location.pathname === `/test/${item}`)
    // ) {
    //   return (
    //     <Navigate
    //       to={`/${slug}`}
    //       replace
    //       state={{ from: location }}
    //     />
    //   );
    // }

  return children;
};

export default TestProtectedRoute;
